import  { useState, useEffect } from 'react';
import './bookPage.css';
import { useNavigate } from 'react-router-dom';

function BookHero({ book }) {
  const [currentCover, setCurrentCover] = useState(book.covers[0]);
  const [isRotating, setIsRotating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (book.covers.length < 2) return;
    const interval = setInterval(() => {
      setIsRotating(true);
      setTimeout(() => {
        setCurrentCover(prev =>
          prev === book.covers[0] ? book.covers[1] : book.covers[0]
        );
      }, 500);
      setTimeout(() => {
        setIsRotating(false);
      }, 1000);
    }, 5000);
    return () => clearInterval(interval);
  }, [book.covers]);

  return (
    <section className="book-hero">
      <div className="book-hero-grid two-columns">

        <div className="book-hero-content">
          <h1 className="book-title">{book.title}</h1>
          <p className="subtitlebook">{book.subtitle}</p>
          <p className="book-description">{book.description}</p>
          <p className="book-availability">{book.availability}</p>

          {book.soldCount && (
            <div className="sold-divider">
              <span className="sold-divider-line" />
              <span className="sold-divider-text">{book.soldCount} </span>
              <span className="sold-divider-line" />
            </div>
          )}

          <div className="hero-buttons">
            {book.previewLink && (
              <a
                href={book.previewLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-btn"
              >
                Read a Preview
              </a>
            )}
            <button
              className="hero-btn secondary"
              onClick={() => navigate('/order/' + book.slug)}
            >
              {book.orderText}
            </button>
          </div>
        </div>

        <div className="book-cover-wrapper">
          <img
            src={currentCover}
            alt={`${book.title} Cover`}
            className={`book-cover-img large ${isRotating ? 'rotate' : ''}`}
          />
        </div>

      </div>
    </section>
  );
}

export default BookHero;